









import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/Header.vue';
import PreservationRecordList from '@/components/surelock/PreservationRecordList.vue';
import preservations from '@/store/modules/preservations';
import PreservationModel from '@/models/PreservationModel';

@Component({
  components: {
    PreservationRecordList,
    Header,
  },
})
export default class SureLock extends Vue {
  links = [
    { text: 'Portal', to: '/' },
    { text: 'SureLock', active: true },
  ];

  async mounted(): Promise<void> {
    await preservations.getPreservations();
  }

  get rows(): Array<PreservationModel> {
    return preservations.filtered;
  }
}

